module.exports = __webpack_public_path__ + "static/media/system.df1e5eb9.png";